/**
 * Inspire-hub 2 (www.giap.pl)
 *
 * Copyright © GIAP sp.z.o.o. All rights reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Karol Pawlak<kpa@giap.pl>, October 2022
 */

/* eslint-disable max-len */
/* flow-disable */

import React, { PropTypes } from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './EServices.css';
import pans from './panStyle.scss';
import _ from 'lodash';
import GrayPanel from '../../components/GrayPanel/GrayPanel';
import PowrotDoListyEuslug from '../../components/PowrotDoListyEuslug/PowrotDoListyEuslug';
import fetch from '../../core/fetch/fetch.server';
import { connect } from 'react-redux';
import { layoutColorStyle, headerStyle, getThemeFromLocalStorage } from '../../components/utils/utils';
import { Col, Row, Table } from 'react-bootstrap';


class FreeDataManager extends React.Component {
    state = {
        eserviceDistrict: null,
        panelEnabled: true,
        counterEnabled: true,
        dataContents: null,
        visible_columns: [
            'sourceType',
            'sourceName',
            'downloadsCount'
        ],
        isMounted: false,
    }

    componentDidMount() {
        const colors = getThemeFromLocalStorage();
        let style = {};
        if (colors !== 'normal') {
          style = {
            color: headerStyle[colors].color,
          };
        }
        if (colors === 'intenseYellowBlack') {
          style = {
            color: headerStyle[colors].backgroundColor,
          };
        }
        this.setState({ colors, style }, this.fetchContent);
    

      }

    componentWillMount() {
        fetch(`${process.env.API_URL}/eservice/${this.props.district}/${this.props.query.serviceType}`)
            .then(r => r.json())
            .then(resp => {
                this.setState({
                    eserviceDistrict: resp
                })
            })
    }

    fetchContent() {
        const url = `${process.env.API_URL}/eservices/${this.props.prefix}/${this.props.query.serviceType}/freeDataContent/`;
        fetch(url)
            .then((response) => {
                if (response.status === 200) {
                    return response.json();
                }
                throw response.json();
            })
            .then((response) => {
                this.setState({
                    panelEnabled: response.content_info.panel_enabled,
                    counterEnabled: response.content_info.counter_enabled,
                    dataContents: response.content_info.contents,
                    isMounted: true,
                });
            })
    }

    afterDownload(sourceName) {
        const url = `${process.env.API_URL}/eservices/${this.props.prefix}/${this.props.query.serviceType}/freeDataContent/${sourceName}/updateCount/`;
        fetch(url, {
            method: 'POST',
          })
        .then((response) => {
            if (response.status === 200) {
                this.fetchContent();
            }
            throw response.json();
        })
    }

    render() {
        return (
            <div style={{ paddingTop: '20px' }}>
                {this.state.isMounted && this.state.panelEnabled ?
                    <div>
                        <h3 style={{ textAlign: 'center' }}>
                        Dane bez opłat - wybierz plik do pobrania.
                        </h3>
                        <GrayPanel title=''>
                            <Row>
                                <Col xs={2}>
                                    <p><b>Rodzaj danych</b></p>
                                </Col>
                                <Col xs={4}>
                                    <p><b>Nazwa pliku</b></p>
                                </Col>
                                <Col xs={this.state.counterEnabled ? 2 : 4}>
                                    <center><b>Data modyfikacji</b></center>
                                </Col>
                                {this.state.counterEnabled ?
                                    <Col xs={2}>
                                        <p><b>Liczba pobrań</b></p>
                                    </Col>
                                : null}
                                
                                <Col xs={2}>
                                    <p><b>Działania</b></p>
                                </Col>
                                <hr></hr>
                            </Row>
                            {this.state.dataContents.map((content, j) => (
                                <Row style={{ marginTop: '5px' }} key={`contentRow${j}`}>
                                    <Col xs={2}>
                                        <p>{content.sourceType}</p>
                                    </Col>
                                    <Col xs={4}>
                                        <p>{content.sourceName}</p>
                                    </Col>
                                    <Col xs={this.state.counterEnabled ? 2 : 4}>
                                        <center>{content.modDate}</center>
                                    </Col>
                                    {this.state.counterEnabled ?
                                        <Col xs={2}>
                                          <center>{content.downloadsCount}</center>
                                        </Col>
                                     : null}
                                  
                                    <Col xs={2}>
                                    <a
                                        type="button"
                                        href={`${process.env.API_URL}/eservices/${this.props.prefix}/${this.props.query.serviceType}/freeDataContent/${encodeURIComponent(content.sourceName)}/`}
                                        id={`downloadbutton${j}`}
                                        className="btn btn-primary"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        onClick={() => this.afterDownload(content.sourceName)}
                                    >
                                        Pobierz
                                    </a>
                                    </Col>
                                </Row>
                                ))
                            }
                        </GrayPanel>
                    </div>
                    : 
                    <h3 style={{ textAlign: 'center' }}>
                        Panel nieaktywny, skontaktuj się z Administratorem.
                    </h3>
                    }
                <div className="row mobile-row">
                    <div className="col-sm-12">
                        <PowrotDoListyEuslug position="left" prefix={this.props.prefix} />
                    </div>
                </div>
            </div>

        );
    }
}

FreeDataManager.propTypes = {
    serviceInfo: PropTypes.object,
    district: PropTypes.string,
};

const mapState = state => ({
    current_service: state.eservices.current,
    districts: state.district.districts
});

const mapDispatch = {
};

export default withStyles(pans)(withStyles(s)(connect(mapState, mapDispatch)(FreeDataManager)));


// WEBPACK FOOTER //
// src/routes/eservices/FreeDataManager.js